import React, { ChangeEvent } from 'react';
import { useForm, Controller } from 'react-hook-form';

import { SaveEmailSubmitButtonGroup } from 'components';
import { SegmentedControl, FormGroup } from 'components/chroma';

import { SingleSegmentedControlStepProps } from 'scenes/common/components/Steps/types';

function SingleSegmentedControlStep<LT, VT>({
  onNext,
  stack,
  options,
  stateKey,
  question,
  helpText,
  helpLink,
  defaultStateValue,
  validationRules,
  onClickSaveQuoteModal,
  onChangeCallback,
}: SingleSegmentedControlStepProps<LT, VT>) {
  const { formState: hooksForm, handleSubmit, control, errors } = useForm({
    mode: 'onChange',
  });

  return (
    <form onSubmit={handleSubmit(onNext)}>
      <Controller
        control={control}
        name={stateKey}
        defaultValue={defaultStateValue}
        rules={{ required: true, ...validationRules }}
        render={({ onChange, value }) => (
          <FormGroup
            id={stateKey}
            legend={question}
            helpText={helpText || ''}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...(helpLink && { helpLink })}
            error={errors[stateKey]?.message || ''}
          >
            <SegmentedControl
              stack={stack}
              id={stateKey}
              name={stateKey}
              values={options}
              value={value}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                onChange(e);
                if (onChangeCallback) {
                  onChangeCallback(e);
                }
              }}
            />
          </FormGroup>
        )}
      />
      <SaveEmailSubmitButtonGroup
        onClickSaveQuoteModal={onClickSaveQuoteModal}
        submitEnabled={hooksForm.isValid}
      />
    </form>
  );
}

export default SingleSegmentedControlStep;
